export default {
  breakpoints: ['650px', '769px', '1441px']
};
